export const faqs = [
  {
    question: 'What exactly is a MindRight Moment?',
    answer: `A MindRight Moment is simply any text message you send to your personal MindRight Partner. You're only charged for the messages you send, never for the valuable guidance and support you receive in response.`,
  },
  {
    question: 'Do my MindRight Moments expire?',
    answer: 'Yes, MindRight Moments expire at the end of each month and do not rollover at this time.',
  }
  // {
  //   question: 'What happens when I run out of MindRight Moments?',
  //   answer:
  //     "After choosing your plan, you'll have the option to set up convenient auto-recharge settings. This ensures you're never left without support exactly when you need it most.",
  // },
];


export const addOnPlanFaq = [
  {
    question: 'What is the “Add-On Moments” option?',
    answer: `"Add-On Moments" allows you to purchase additional message credits on top of your current plan for the same month. It’s perfect when you need extra support or more conversations with your coach.`,
  },
  {
    question: 'Do added Moments roll over to the next month?',
    answer: `No — any Moments added through this option expire at the end of the current month, just like your regular Moments. Be sure to use them within the month you purchase them.`,
  },
  {
    question: 'Can I cancel or get a refund after adding more Moments?',
    answer: `No — once you purchase additional Moments, they cannot be canceled, refunded, or carried over. Please review your selection carefully before confirming.`,
  },
];